module.exports = __webpack_public_path__ + "static/media/hubspotProcess4.42169109.png";